/**
 * Newsletter CTA form handler for app pages.
 *
 * Enhances .newsletter-cta__form elements with fetch-based submission.
 * On success, shows inline confirmation (no redirect — user stays on page).
 */

const SUBSCRIBE_URL = "/api/newsletter/subscribe";

function showError(form: HTMLFormElement, text: string) {
  let msg = form.querySelector<HTMLElement>(".newsletter-cta__error");
  if (!msg) {
    msg = document.createElement("p");
    msg.className = "newsletter-cta__error";
    form.appendChild(msg);
  }
  msg.textContent = text;
}

function handleSubmit(form: HTMLFormElement) {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const input = form.querySelector<HTMLInputElement>('input[type="email"]');
    const button = form.querySelector<HTMLButtonElement>("button");
    if (!input || !button) return;

    const email = input.value.trim();
    if (!email) return;

    button.disabled = true;
    button.textContent = "Subscribing\u2026";

    try {
      const res = await fetch(SUBSCRIBE_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json<{ status?: string; error?: string }>();

      if (res.ok && data.status === "ok") {
        form.innerHTML =
          '<p class="newsletter-cta__success">Check your inbox for a verification link.</p>';
      } else if (data.status === "exists") {
        form.innerHTML =
          '<p class="newsletter-cta__success">You\'re already subscribed. <a href="https://auth.formthirteen.com/login?redirect_uri=' +
          encodeURIComponent("https://formthirteen.com/subscriptions") +
          '">Sign in</a> to manage your subscription.</p>';
      } else {
        button.textContent = "Subscribe Free";
        button.disabled = false;
        showError(form, data.error || "Something went wrong. Try again.");
      }
    } catch {
      button.textContent = "Subscribe Free";
      button.disabled = false;
      showError(form, "Network error. Try again.");
    }
  });
}

document
  .querySelectorAll<HTMLFormElement>(".newsletter-cta__form")
  .forEach(handleSubmit);

export {};
